const products = [
  {
    id: 1,
    name: "Paket Trial",
    normalPrice: 1150000,
    promoPrice: 800000,
    includeFeatures: [
      {
        name: "15 Desain Feed (Single Image, Product Showcase)",
      },
      {
        name: "3 Video Content (Reels)",
      },
      {
        name: "Research Hastag",
      },
      {
        name: "Copywriting",
      },
      {
        name: "Revisi Fleksibel",
      },
    ],
    excludeFeatures: [
      {
        name: "Admin Posting",
      },
      {
        name: "Content Planning",
      },
      {
        name: "Bio Instagram",
      },
      {
        name: "SEO (Google Map, Google Review)",
      },
      {
        name: "Private Group",
      },
    ],
  },
  {
    id: 2,
    name: "Paket Standar",
    normalPrice: 1550000,
    promoPrice: 1250000,

    includeFeatures: [
      {
        name: "21 Desain Feed (Single Image, Product Showcase)",
      },
      {
        name: "5 Video Content (Reels)",
      },
      {
        name: "Research Hastag",
      },
      {
        name: "Copywriting",
      },
      {
        name: "Revisi Fleksibel",
      },
      {
        name: "Admin Posting",
      },
      {
        name: "Content Planning",
      },
      {
        name: "Bio Instagram",
      },
    ],
    excludeFeatures: [
      {
        name: "Private Group",
      },
      {
        name: "SEO (Google Map, Google Review)",
      },
    ],
  },
  {
    id: 3,
    name: "Paket Platinum",
    normalPrice: 2000000,
    promoPrice: 1550000,
    includeFeatures: [
      {
        name: "24 Desain Feed (Single Image, Product Showcase)",
      },
      {
        name: "8 Video Content (Reels)",
      },
      {
        name: "Research Hastag",
      },
      {
        name: "Copywriting",
      },
      {
        name: "Revisi Fleksibel",
      },
      {
        name: "Admin Posting",
      },
      {
        name: "Content Planning",
      },
      {
        name: "Private Group",
      },
      {
        name: "Instagram Bio",
      },
      {
        name: "SEO (Google Map, Google Review)",
      },
    ],
    excludeFeatures: [],
  },
];

export default products;
